if (!customElements.get('linked-select')) {
  class LinkedSelect extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('select');
    }
    connectedCallback() {
      if (this.select) {
        this.select.addEventListener('change', (event) => {
          const value = event.target.value;
          if (value) {
            window.location.href = value;
          }
        });
      }
    }
  }
  customElements.define('linked-select', LinkedSelect);
}
